module.exports = __webpack_public_path__ + "img/SharingRecords01.dc7af270.svg";